import { createSlice } from "@reduxjs/toolkit";

const initialLogLoginState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminLogLoginSlice = createSlice({
  name: "logLogin",
  initialState: initialLogLoginState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // findaccessRole
    logLoginFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
  }
});
